import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function Manufacturer(props) {
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const { globalfilter, screen, updateParent,reset, type } = props;
    const [formObj, setFormObj] = useState(FilterObj);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [TOTmanufacture, setTOTmanufacture] = React.useState([]);
    const [filteredString, setValue] = useState("");
    const autoTextSampleStatus = async(event) => {
        const searchStr = event.target.value;
        setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/TOTmanufacture/${searchStr}`;
        await getRequest(url)
            .then((res) => {
                console.log("Responce", res);
                if (res.status == 200) {
                    //let obj = { "lastKnownLubeGrade": "All" };
                    let data = res.data;
                    let result = data?.map((a, i) => {
                        return { id: a?.manufacturer, name: a?.manufacturer };
                    });
                    if (selectedvalue) {
                        selectedvalue.forEach((val, i) => {
                            result = result.filter((ele) => ele.name != val.name)
                        })
                    }
                    setTOTmanufacture(result);

                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                // dispatch({ type: LOADING, payload: false });
                //console.log(error);
                // ToastError(error.response.data.message);
            });


    }
    const handleChange = (event, newValue) => {
        //
        props.onChange(newValue);
        const filteredTotmanufacture = {
            ...formObj,
            Totmanufacture: newValue
        };
        setFormObj(filteredTotmanufacture);
        setselectedvalue(newValue);
        setValue("");
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('TOTFilterSetting'));
            Obj = {
                ...Obj,
                Totmanufacture: newValue
            }
            localStorage.setItem("TOTFilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        //
        let filtervalue = JSON.parse(localStorage.getItem('TOTFilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                Totmanufacture: filtervalue.Totmanufacture
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.Totmanufacture);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.Totmanufacture);
            console.log('getcookievalue', formObj)
        }else{
            setFormObj({});
        }
    }
    React.useEffect(() => {
        //
        if (reset>0)
        defaultValue(GlobalFilterSettingValue);
        
    }, [reset]);
    React.useEffect(() => {
        //
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                // fullWidth  Totmanufacture
                value={formObj.Totmanufacture || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={TOTmanufacture}
                getOptionLabel={(option) => option.name}
                //defaultValue={[top100Films[13]]}
                onChange={(event, newValue) => handleChange(event, newValue)}
                inputValue={filteredString}

                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Manufacturer"
                        //placeholder="Favorites"
                        onChange={autoTextSampleStatus}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
